<template>
  <!-- on verifie dans le store que le user n'est pas null 
  donc la personne est connecté ainsi que les roles pour la liste déroulante qui apparaitra à gauche sur la page d'acceuil -->
  <template v-if="this.$store.state.user !== null">
    <template v-if="this.$store.state.user.role.label == 'admin'">
      <div class="dropdown">
        <img class="dropbtn me-3" id="iconNav"
          src="https://www.clipartmax.com/png/full/36-365828_navbar-toggle-icon-menu-hamburger-png-white.png" />

        <div class="dropdown-content">
          <router-link to="/Agence"><a href="#">Agence</a></router-link>
          <router-link to="/Lycee"><a href="#">Lycee</a></router-link>
          <router-link to="/Vehicule"><a href="#">Vehicule</a></router-link>
          <router-link to="/Moniteur"><a href="#">Moniteur</a></router-link>
          <router-link to="/LieuRDV"><a href="#">LieuRDV</a></router-link>
          <router-link to="/LieuEXAM"><a href="#">LieuExam</a></router-link>
          <router-link to="/Eleve"><a href="#">Eleve</a></router-link>
          <router-link to="/admin/code"><a href="#">Code</a></router-link>
          <router-link to="/TrameFront"><a href="#">Trame</a></router-link>

          <router-link to="/Statistique"><a href="#">Statistique</a></router-link>
          <router-link to="/JourneePorteOuverte"><a href="#">Journee porte ouverte</a></router-link>
          <router-link to="/agence/stagecode"><a href="#">Stage de code</a></router-link>
          <router-link to="/Fonctionnalite"><a href="#">Fonctionnalite</a></router-link>
          <router-link to="/admin/formationAac"><a href="#">Formation AAC</a></router-link>
          <router-link to="/OtherPaiementDeleted"><a href="#">Paiements supprimés</a></router-link>
          <a href="#" @click="deconnexion">Déconnexion</a>
        </div>
      </div>
    </template>

    <template v-if="this.$store.state.user.role.label == 'secretaire'">
      <div class="dropdown">
        <img class="dropbtn me-3" id="iconNav"
        src="https://www.clipartmax.com/png/full/36-365828_navbar-toggle-icon-menu-hamburger-png-white.png" />

        <div class="dropdown-content">
          <div class="subMenu">
            <div class="subTitleMenu">
              <a>Quotidien > </a>
            </div>
            <div class="subMenus">
                <router-link to="/AgenceEleve"><a href="#">Eleves</a></router-link>
                <router-link to="/agence/dossier"><a href="#">Dossier</a></router-link>
                <router-link to="/secretaire/code"><a href="#">Code à livrer</a></router-link>
                <router-link to="/agence/planning"><a href="#" @click="planningExec">Planning</a></router-link>

                <div class="subMenu">
                  <div class="subTitleMenu">
                    <a>Examen</a>
                  </div>
                  <div class="subMenus">
                      <router-link to="/gestion/examcode"><a href="#">Code</a></router-link>
                      <a href="#">Conduite</a>
                  </div>
                </div>

            </div>
          </div>
          <div class="subMenu">
            <div class="subTitleMenu">
              <a>Occasionnel > </a>
            </div>
            <div class="subMenus">
                <router-link to="/Donnees"><a href="#">Agence</a></router-link>
                <router-link to="/agence/lieux"><a href="#">Lieux</a></router-link>
                <router-link to="/OtherPaiementDeleted"><a href="#">Paiements Archivés</a></router-link>
                <router-link to="/transfert/eleve"><a href="#">Transferts Eleves</a></router-link>
            </div>
          </div>
          <a href="#" @click="deconnexion">Déconnexion</a>
        </div>
      </div>
    </template>

    <template v-if="this.$store.state.user.role.label == 'eleve'">
      <div class="dropdown">
        <img class="dropbtn mt-4" id="iconNav"
          src="https://www.clipartmax.com/png/full/36-365828_navbar-toggle-icon-menu-hamburger-png-white.png" />

        <div class="dropdown-content">
          <router-link to="/JourneePorteOuverteEleve"><a href="#">Evénements</a></router-link>
          <router-link v-if="checkOnePaiement('dossier')" :to="{ name: 'Dossier', params: { personalData: 'true' } }"><a
              href="#">Formulaire</a></router-link>
          <router-link to="/CodeFront"><a href="#">Code</a></router-link>
          <a href="#" @click="deconnexion">Déconnexion</a>
        </div>
      </div>
    </template>
    <template v-if="this.$store.state.user.role.label == 'moniteur'">
      <div class="dropdownmono">
        <img class="dropbtn" id="iconNav" @click="showDropMonoNav"
          src="https://www.clipartmax.com/png/full/36-365828_navbar-toggle-icon-menu-hamburger-png-white.png" />

        <div class="dropdown-contentmono">
          <div class="nav-item">
            <div class="mpanel-ico" style="background:#fdf2f8;">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#d946a8" stroke-width="1.5"/></svg>
            </div>
            <router-link to="/home"><a href="#">Accueil</a></router-link>
          </div>
          
          <div class="nav-item">
            <div class="mpanel-ico" style="background:#e8f7f1;">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke="#1a9e6e" stroke-width="1.5"/><path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
            </div>
            <router-link to="/eleves/exam"><a href="#">Elèves Exam</a></router-link>
          </div>
          <div class="nav-item">
            <div class="mpanel-ico" style="background:#f5f3ff;">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4" stroke="#8b5cf6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#8b5cf6" stroke-width="1.5"/></svg>
            </div>
            <router-link to="/planning/exams"><a href="#">Planning Exam</a></router-link>
          </div>
          <div class="nav-item">
            <div class="mpanel-ico" style="background:#e8f7f1;">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#1a9e6e" stroke-width="1.5"/><path d="M3 10h18M8 4V2M16 4V2" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
            </div>
            <router-link to="/PlanningMonoFront"><a href="#">Planning</a></router-link>
          </div>
          <div class="disconnect">
            <div class="mpanel-ico" style="background:#fff1f2">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="#f43f5e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <a href="#" @click="deconnexion">Déconnexion</a>
          </div>
          
        </div>
      </div>
    </template>
  </template>
</template>

<script>
export default {
  name: "DropdownNav",

  data() {
    return {
      clickNavMono : false,
    }
  },

  methods: {

    planningExec(){
      this.$store.commit('setSplitPage', false);
    },

    deconnexion() {
      this.$store.commit("setUser", null);
      this.$store.commit("setToken", null);
      localStorage.removeItem("user_info");
      localStorage.removeItem("user_access");
    },

    showDropMonoNav(){
      if(this.clickNavMono === false){
        this.clickNavMono = true;
        document.querySelector("div.dropdown-contentmono").style.display = "block";
      }else{
        this.clickNavMono = false;
        document.querySelector("div.dropdown-contentmono").style.display = "none";
      }
    }
  },
  
};
</script>

<style scoped>
#iconNav {
  width: 35px;
  height: 35px;
}

div.dropdownmono{
  padding-top: 5px;
  margin-right: 10px;
}

/* Style The Dropdown Button */
.dropbtn {
  color: white;
  border: none;
  cursor: pointer;

}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: white;
  padding: 6px 10px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  border-radius: 17px;
  background: transparent linear-gradient(131deg, #de6fa8 0%, #fbbb5b 100%) 0% 0% no-repeat padding-box;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
  border-radius: 17px;
  background: transparent linear-gradient(131deg, #de6fa8 0%, #fbbb5b 100%) 0% 0% no-repeat padding-box;
}

.subMenus{
  display: none;
  position: absolute;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  
}
.dropdown-content .subMenu:hover .subMenus{
  display: block;
  position: absolute;
  left:100%; 
  border-radius: 17px;
  background: transparent linear-gradient(131deg, #de6fa8 0%, #fbbb5b 100%) 0% 0% no-repeat padding-box;
}

.dropdown-content .subMenu{
  display: inline-flex;
  width: 100%;
}

.dropdown-content .subMenu div.subTitleMenu a{
  color: white;
  padding: 6px 10px;
  text-decoration: none;
  display: block;
}

.dropdown-content .subMenu div.subTitleMenu{
  width: 100%;
}

/** MONO NAV */

/* Dropdown Content (Hidden by Default) */
.dropdown-contentmono {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-bottom-right-radius: 16px;
  top: 4.9vh;
  left: 0;

}

/* Links inside the dropdown */
.dropdown-contentmono a {
  color: black;
  text-decoration: none;
  display: block;
  text-align: left;
}

.nav-item{
 display: flex; 
 align-items: center; 
 gap: 10px; 
 padding: 10px;
}

.mpanel-ico{
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.disconnect{
  display: flex; 
  align-items: center; 
  gap: 10px; 
  padding: 10px;
  border-top: 1px solid #e2e8f0;
  width: 100%;

  
}

.disconnect a {
  color: #f43f5e;
}


</style>
